import { Injectable } from '@angular/core';
import { IConnectorChargingBenefitsDTO, IEnergyWalletBalanceDTO, IEnergyWalletMovement, RecordCounted } from 'common_library';
import { HttpIoService } from '../communication/http-io.service';

@Injectable({ providedIn: 'root' })
export class EnergyWalletService {
  constructor(private HIO: HttpIoService) {}

  async getMine(): Promise<IEnergyWalletBalanceDTO> {
    return this.HIO.get<IEnergyWalletBalanceDTO>('energy-wallet/me');
  }

  async getMyMovements(page = 0, search = '', pageSize = 20): Promise<RecordCounted<IEnergyWalletMovement>> {
    return this.HIO.get<RecordCounted<IEnergyWalletMovement>>(
      `energy-wallet/me/movements?page=${page}&search=${encodeURIComponent(search)}&pageSize=${pageSize}`,
    );
  }

  async getConnectorChargingBenefits(connectorId: number): Promise<IConnectorChargingBenefitsDTO> {
    return this.HIO.get<IConnectorChargingBenefitsDTO>(`core/connector-charging-benefits/${connectorId}`);
  }
}
